<template>
  <Modal id="forgot-password" modifier="auth" @close="removeQuery">
    <template v-if="!submitted">
      <h1>{{ $t('ModalForgotPassword.title') }}</h1>
      <div class="about">{{ $t('ModalForgotPassword.about') }}</div>
      <form action="#" @submit.prevent="submit">
        <input type="email" placeholder="e-mail" v-model="email" required />
        <button class="primary large" type="submit">{{ $t('submit') }}</button>
      </form>

      <div class="error-block" v-if="errors.length">
        <p v-for="errorMsg in errors" :key="errorMsg">
          {{ errorMsg }}
        </p>
      </div>
      <div class="message-block" v-if="messages.length">
        <p v-for="message in messages" :key="message">
          {{ message }}
        </p>
      </div>
    </template>
    <template v-else>
      <h1>{{ $t('ModalForgotPassword.checkEmail') }}</h1>
      <div class="about">{{ $t('ModalForgotPassword.aboutEmail') }} {{ email }}</div>
      <div class="about">
        {{ $t('ModalForgotPassword.aboutEmailNotify') }} {{ email }}
        <a href="#" @click.prevent="submitted = false">{{ $t('resend') }}</a>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import { APP_API_BASE } from '@/const/api'
export default {
  name: 'ModalForgotPassword',
  components: { Modal },
  data: () => ({
    email: '',
    errors: [],
    messages: [],
    submitted: false,
  }),
  methods: {
    removeQuery() {
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          forgot: undefined,
        },
      })
    },
    submit() {
      this.errors = []
      this.messages = []

      fetch(APP_API_BASE + '/api/password/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: this.email,
        }),
      })
        .then(async (response) => {
          if (!response.ok) {
            return Promise.reject(response)
          }

          return response.json()
        })
        .then((responseData) => {
          this.submitted = true
          this.messages.push(responseData.message)
        })
        .catch((response) => {
          if (response.status === 413) {
            this.errors.push(this.$t('ModalForgotPassword.error'))
          }

          return response.json().then(
            (errorData) => {
              console.log(errorData)
              if (errorData?.hasOwnProperty('errors')) {
                for (let field in errorData.errors) {
                  for (let i = 0; i < errorData.errors[field].length; i++) {
                    this.errors.push(errorData.errors[field][i])
                  }
                }
              } else {
                this.errors.push(this.$t('serverError'))
              }
            },
            (rejectData) => {
              console.log(rejectData)
            }
          )
        })
    },
  },
}
</script>
